export const ALERTAS_PERMISSIONS = {
	VISUALIZAR: "GRD:ALERTAS:VISUALIZAR",

	GERENCIAR: "GRD:ALERTAS:GERENCIAR"
};

export const DACA_PERMISSIONS = {
	VISUALIZAR: "GRD:DACA:VISUALIZAR",

	GERENCIAR_ITEM: "GRD:DACA:GERENCIARITEM",
	GERENCIAR_ENTRADA: "GRD:DACA:GERENCIARENTRADA",
	GERENCIAR_SAIDA: "GRD:DACA:GERENCIARSAIDA",
	GERENCIAR_SAIDA_REGIONAL: "GRD:DACA:GERENCIARSAIDAREG",
	GERENCIAR_DEVOLUCAO: "GRD:DACA:GERENCIARDEVOLUCAO",
	GERENCIAR_DEVOLUCAO_REGIONAL: "GRD:DACA:GERENCIARDEVREG",
	GERENCIAR_MOVIMENTACAO: "GRD:DACA:GERENCIARMOV",
	GERENCIAR_MOVIMENTACAO_REGIONAL: "GRD:DACA:GERENCIARMOVREG"
};

export const CENTRAL_DOACOES_PERMISSIONS = {
	VISUALIZAR: "GRD:CENTRALDOACOES:VISUALIZAR",

	GERENCIAR_ITEM: "GRD:CENTRALDOACOES:GERENCIARITEM",
	GERENCIAR_OFICIO: "GRD:CENTRALDOACOES:GERENCIAROFICIO",
	GERENCIAR_ENTIDADE: "GRD:CENTRALDOACOES:GERENCIARENTIDADE",
	GERENCIAR_ENTRADA: "GRD:CENTRALDOACOES:GERENCIARENTRADA",
	GERENCIAR_SAIDA: "GRD:CENTRALDOACOES:GERENCIARSAIDA"
};

export const PRESTACAO_CONTAS_PERMISSIONS = {
	VISUALIZAR: "GRD:PRESTACAOCONTAS:VISUALIZAR",
	LISTAGEM_MUNICIPAL: "GRD:PRESTACAOCONTAS:LISTAGEMMUNICIPAL",
	LISTAGEM_REGINONAL: "GRD:PRESTACAOCONTAS:LISTAGEMREGIONAL",
	LISTAGEM_ESTADUAL: "GRD:PRESTACAOCONTAS:LISTAGEMESTADUAL",

	PRESTAR_CONTAS: "GRD:PRESTACAOCONTAS:PRESTARCONTAS",
	ANALISAR_CREPDEC: "GRD:PRESTACAOCONTAS:ANALISARCREPDEC",
	ANALISAR_DACA: "GRD:PRESTACAOCONTAS:ANALISARDACA",
	ANALISAR_SUB_CHEFE: "GRD:PRESTACAOCONTAS:ANALISARSUBCHEFE",
	REVISAR: "GRD:PRESTACAOCONTAS:REVISAR"
};

export const PLANO_CONTIGENCIA_MUNICIPAL_PERMISSIONS = {
	VISUALIZAR_MUNICIPAL: "GRD:PCMUNICIPAL:VISUALIZARMUNICIPAL",
	VISUALIZAR_REGIONAL: "GRD:PCMUNICIPAL:VISUALIZARREGIONAL",
	VISUALIZAR_ESTADUAL: "GRD:PCMUNICIPAL:VISUALIZARESTADUAL",

	CADASTRAR: "GRD:PCMUNICIPAL:CADASTRAR",
	RETIFICAR: "GRD:PCMUNICIPAL:RETIFICAR",
	APROVAR: "GRD:PCMUNICIPAL:APROVAR"
};

export const PLANO_CONTIGENCIA_ESTADUAL_PERMISSIONS = {
	VISUALIZAR: "GRD:PCESTADUAL:VISUALIZAR",
	CADASTRAR: "GRD:PCESTADUAL:CADASTRAR",
	RETIFICAR: "GRD:PCESTADUAL:RETIFICAR",
	APROVAR: "GRD:PCESTADUAL:APROVAR"
};

export const RELATORIO_VISTORIA_PERMISSIONS = {
	VISUALIZAR: "GRD:RELATORIOVISTORIA:VISUALIZAR",

	LISTAGEM_ESTADUAL: "GRD:RELATORIOVISTORIA:LISTAGEMESTADUAL",
	CADASTRAR_ESTADUAL: "GRD:RELATORIOVISTORIA:CADASTRARESTADUAL",
	EDITAR_ESTADUAL: "GRD:RELATORIOVISTORIA:EDITARESTADUAL",

	LISTAGEM_REGIONAL: "GRD:RELATORIOVISTORIA:LISTAGEMREGIONAL",
	CADASTRAR_REGIONAL: "GRD:RELATORIOVISTORIA:CADASTRARREGIONAL",
	EDITAR_REGIONAL: "GRD:RELATORIOVISTORIA:EDITARREGIONAL",

	APROVAR: "GRD:RELATORIOVISTORIA:APROVAR"
};

export const PLANO_DETALHADO_PERMISSIONS = {
	VISUALIZAR_MUNICIPAL: "GRD:PDR:VISUALIZARMUNICIPAL",
	VISUALIZAR_REGIONAL: "GRD:PDR:VISUALIZARREGIONAL",
	VISUALIZAR_ESTADUAL: "GRD:PDR:VISUALIZARESTADUAL",

	CADASTRAR: "GRD:PDR:CADASTRAR",

	ANALISAR_REGIONAL: "GRD:PDR:ANALISARREGIONAL",
	ANALISAR_DACA: "GRD:PDR:ANALISARDACA",
	ANALISAR_FINANCA: "GRD:PDR:ANALISARFINANCA",
	ANALISAR_SUBCHEFE: "GRD:PDR:ANALISARSUBCHEFE",
	AANALISAR_COORDEST: "GRD:PDR:ANALISARCOORDEST",

	EXCLUIR: "GRD:PDR:EXCLUIR",
	REVISAR: "GRD:PDR:REVISAR",
	CANCELAR: "GRD:PDR:CANCELAR",
	ACUSAR_RECEBIMENTO: "GRD:PDR:ACUSARRECEBIMENTO"
};

export const PLANO_TRABALHO_PERMISSIONS = {
	VISUALIZAR_MUNICIPAL: "GRD:PLANOTRABALHO:VISUALIZARMUNICIPAL",
	VISUALIZAR_REGIONAL: "GRD:PLANOTRABALHO:VISUALIZARREGIONAL",
	VISUALIZAR_ESTADUAL: "GRD:PLANOTRABALHO:VISUALIZARESTADUAL",

	CADASTRAR: "GRD:PLANOTRABALHO:CADASTRAR",

	ANALISAR_REGIONAL: "GRD:PLANOTRABALHO:ANALISARREGIONAL",
	ANALISAR_DACA: "GRD:PLANOTRABALHO:ANALISARDACA",
	ANALISAR_FINANCA: "GRD:PLANOTRABALHO:ANALISARFINANCA",
	ANALISAR_SUBCHEFE: "GRD:PLANOTRABALHO:ANALISARSUBCHEFE",
	ANALISAR_COORDEST: "GRD:PLANOTRABALHO:ANALISARCOORDEST",

	EXCLUIR: "GRD:PLANOTRABALHO:EXCLUIR",
	REVISAR: "GRD:PLANOTRABALHO:REVISAR",
	CANCELAR: "GRD:PLANOTRABALHO:CANCELAR"
};

export const BOLETIM_INFORMATIVO_PERMISSIONS = {
	VISUALIZAR_EMAIL: "GRD:COMUNICACAOSOCIAL:VISUALIZAR_EMAIL",
	GERENCIAR_EMAIL: "GRD:COMUNICACAOSOCIAL:GERENCIAREMAIL",
	VISUALIZAR_NOTICIA: "GRD:COMUNICACAOSOCIAL:VISUALIZARNOTICIA",
	GERENCIAR_NOTICIA: "GRD:COMUNICACAOSOCIAL:GERENCIARNOTICIA"
};

export const COMANDO_INCIDENTES_PERMISSIONS = {
	VISUALIZAR: "GRD:SCI:VISUALIZAR",
	GERENCIAR: "GRD:SCI:GERENCIAR"
};

export const DASHBOARD_PERMISSIONS = {
	VISUALIZAR_PUBLICO: "GRD:DASHBOARD:VISUALIZAPAINELPUBL",
	VISUALIZAR_PRIVADO: "GRD:DASHBOARD:VISUALIZAPAINELPRIV",
};
